export const DEMO_IDS = {
    fabricante: 900010,
    modelo: 900011,
    operadora: 900012,
    tipoAcesso: 900020,
    tipoMonitorado: 900013,
    equipamento: 900001,
    perfil: 900002,
    cliente: 900003,
    monitorado: 900004,
    campoTemp: 900101,
    campoStatus: 900102,
    supervisorio: 900030,
    permissaoBase: 900200,
}

export const DEMO_IMEI = 'DEMO000000000001'
export const DEMO_MQTT_USER = 'demo_mqtt_device'
export const DEMO_MQTT_PASSWORD = 'demo1234'
export const DEMO_MQTT_TOPIC_PUB = 'demo/01/pub'
export const DEMO_MQTT_TOPIC_SUB = 'demo/01/sub'

export const mqttPacketPayload = {
    id: 'DEMO000000000001',
    timestamp: Math.floor(Date.now() / 1000),
    rede: 'M1',
    sinal: -85,
    analogicas: [12.48, 3.21, 0.06, 24.53],
    digitais: [1, 0, 1, 0],
    dl_status: [1, 0],
    dl_horimetro: [18234.5, 120.2],
    dl_cont_pulso: [458912, 1024],
    d_status: [1, 0],
    d_horimetro: [9401.75, 85.4],
    d_cont_pulso: [221004, 880],
    ct_pulso: [999, 999],
    tensao: 13.8,
    corrente: 2.41,
    energia: 42.6,
    temperatura: 24.5,
    vazao: 8.7,
    nivel: 3.42,
    horas: 2.15,
    volume_hidrometro: 14.8,
    bateria: 87.4,
    umidade: 61.2,
    status: {
        online: true,
        modo: 'operacao',
        alarme: false,
    },
    meta: {
        firmware: '2.4.1-demo',
        imei: DEMO_IMEI,
        usuario_mqtt: DEMO_MQTT_USER,
    },
}

export const mqttLastReport = JSON.stringify(mqttPacketPayload)
